import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-squint': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM353.6 304.6C327.7 312.9 289.2 317.7 248 317.7S168.4 312.9 142.4 304.6C132.5 301.5 123 310 124.7 319.9 132.6 367 196 399.9 248 399.9S363.3 367 371.3 319.9C372.9 310.1 363.6 301.5 353.6 304.6zM118.9 263.8C122.5 268 128.8 269.5 134.2 266.3L214.2 218.3C217.8 216.1 220 212.2 220 208S217.8 199.9 214.2 197.7L134.2 149.7C129.1 146.7 122.8 147.8 118.9 152.2 115.1 156.7 115.1 163.2 118.8 167.7L152.4 208 118.8 248.3C115 252.8 115.1 259.4 118.9 263.8zM361.8 266.3C367.2 269.5 373.5 268 377.1 263.8 380.9 259.3 380.9 252.8 377.2 248.3L343.6 208 377.2 167.7C381 163.2 380.9 156.7 377.1 152.2 373.3 147.8 366.9 146.8 361.8 149.7L281.8 197.7C278.2 199.9 276 203.8 276 208S278.2 216.1 281.8 218.3L361.8 266.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-squint.js
// module id = puA4
// module chunks = 144